import { agentProfileIdSchema } from "../protocol/profile.js";
import { agentProfileWorkRecoveryActionKindSchema } from "../agent-profile-work-recovery.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/agent-profile-work-recovery.ts
const agentProfileWorkRecoveryActionSchema = agentProfileWorkRecoveryActionKindSchema;
const agentProfileWorkRecoveryRouteParamsSchema = z$1.strictObject({ agentProfileId: agentProfileIdSchema });
const executeAgentProfileWorkRecoveryBodySchema = z$1.discriminatedUnion("action", [
	z$1.strictObject({ action: z$1.literal("continue_interrupted_work") }),
	z$1.strictObject({ action: z$1.literal("approve_queued_work") }),
	z$1.strictObject({
		action: z$1.literal("skip_interrupted_work"),
		expectedInterruptedTargetWakeLifecycleId: z$1.string().trim().min(1).max(512)
	}),
	z$1.strictObject({
		action: z$1.literal("fork_interrupted_work"),
		expectedInterruptedTargetWakeLifecycleId: z$1.string().trim().min(1).max(512)
	})
]);
const executeAgentProfileWorkRecoveryResponseSchema = z$1.strictObject({
	action: agentProfileWorkRecoveryActionSchema,
	status: z$1.literal("accepted")
});
//#endregion
export { agentProfileWorkRecoveryActionSchema, agentProfileWorkRecoveryRouteParamsSchema, executeAgentProfileWorkRecoveryBodySchema, executeAgentProfileWorkRecoveryResponseSchema };

//# sourceMappingURL=agent-profile-work-recovery.js.map